import React from 'react';

import HectorIcon from '../assets/icons/HectorIcon.jsx';
import FAQ from '../components/FAQ.js';

const NewChat = ({ setPrompt }) => {
  return (
    <div className="flex flex-9 items-center justify-center flex-col flex-1 overflow-auto mx-auto gap-3 md:px-5 lg:px-1 xl:px-5 md:max-w-3xl">
      <div className="flex flex-col w-4/5 items-center justify-center p-5 h-chatHeight">
        <div className="pb-2">
          <HectorIcon className="h-12 w-12" />
        </div>
        <FAQ setPrompt={setPrompt} />
      </div>
    </div>
  );
};

export default NewChat;
